import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../index';

type SlcDetailsState = {
  selectedSlcId: string | null;
  selectedIccid: string | null;
  selectedStatus: string | null;
  selectedUserType: string | null;
  selectedEnterpriseId: number | null;
};

const initialState: SlcDetailsState = {
  selectedSlcId: null,
  selectedIccid: null,
  selectedStatus: null,
  selectedUserType: null,
  selectedEnterpriseId: null,
};

const slcDetailsSlice = createSlice({
  name: 'slcDetails',
  initialState,
  reducers: {
    setSelectedSlc: (
      state,
      action: PayloadAction<{
        slcId: string;
        iccid: string;
        status: string;
        userType?: string;
        enterpriseId?: number | null;
      }>
    ) => {
      state.selectedSlcId = action.payload.slcId;
      state.selectedIccid = action.payload.iccid;
      state.selectedStatus = action.payload.status;
      state.selectedUserType = action.payload.userType ?? null;
      state.selectedEnterpriseId = action.payload.enterpriseId ?? null;
    },
    clearSelectedSlc: (state) => {
      state.selectedSlcId = null;
      state.selectedIccid = null;
      state.selectedStatus = null;
      state.selectedUserType = null;
      state.selectedEnterpriseId = null;
    },
    updateSlcStatus: (state, action: PayloadAction<string>) => {
      state.selectedStatus = action.payload;
    },
    updateSelectedIccid: (state, action: PayloadAction<string>) => {
      state.selectedIccid = action.payload;
    },
  },
});

export const {
  setSelectedSlc,
  clearSelectedSlc,
  updateSlcStatus,
  updateSelectedIccid,
} = slcDetailsSlice.actions;

export const selectSelectedSlcId = (state: RootState) =>
  state.slcDetails.selectedSlcId;
export const selectSelectedIccid = (state: RootState) =>
  state.slcDetails.selectedIccid;
export const selectSelectedStatus = (state: RootState) =>
  state.slcDetails.selectedStatus;
export const selectSelectedUserType = (state: RootState) =>
  state.slcDetails.selectedUserType;
export const selectSelectedEnterpriseId = (state: RootState) =>
  state.slcDetails.selectedEnterpriseId;
export const selectSlcDetails = (state: RootState) => state.slcDetails;

export default slcDetailsSlice.reducer;
